import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a4504c7ca334e001419cebe_1783185711429_b0f121d7/aimtrainer/src/app/page.tsx");
